export default __webpack_public_path__ + "static/media/mad-pigeon.98a00d05.jpg";